var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusAnimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 196,
    viewBox: "0 0 196 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.91 158.819V193",
    stroke: "#EF767A",
    strokeWidth: 5.23432,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    className: "qvncsRce_0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.819 175.91H193",
    stroke: "#EF767A",
    strokeWidth: 5.23432,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    className: "qvncsRce_1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.947 106.856V141.037",
    stroke: "#EF767A",
    strokeWidth: 5.23432,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    className: "qvncsRce_2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.856 123.947H141.037",
    stroke: "#EF767A",
    strokeWidth: 5.23432,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    className: "qvncsRce_3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0527 54.9629V89.0744",
    stroke: "#EF767A",
    strokeWidth: 5.23432,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    className: "qvncsRce_4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9627 71.9839H89.0742",
    stroke: "#EF767A",
    strokeWidth: 5.23432,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    className: "qvncsRce_5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0898 3V37.1806",
    stroke: "#EF767A",
    strokeWidth: 5.23432,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    className: "qvncsRce_6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99904 20.0903H37.1797",
    stroke: "#EF767A",
    strokeWidth: 5.23432,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    className: "qvncsRce_7"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    "data-made-with": "vivus-instant"
  }, ".qvncsRce_0{stroke-dasharray:35 37;stroke-dashoffset:36;animation:qvncsRce_draw_0 6200ms linear 0ms infinite,qvncsRce_fade 6200ms linear 0ms infinite;}.qvncsRce_1{stroke-dasharray:35 37;stroke-dashoffset:36;animation:qvncsRce_draw_1 6200ms linear 0ms infinite,qvncsRce_fade 6200ms linear 0ms infinite;}.qvncsRce_2{stroke-dasharray:35 37;stroke-dashoffset:36;animation:qvncsRce_draw_2 6200ms linear 0ms infinite,qvncsRce_fade 6200ms linear 0ms infinite;}.qvncsRce_3{stroke-dasharray:35 37;stroke-dashoffset:36;animation:qvncsRce_draw_3 6200ms linear 0ms infinite,qvncsRce_fade 6200ms linear 0ms infinite;}.qvncsRce_4{stroke-dasharray:35 37;stroke-dashoffset:36;animation:qvncsRce_draw_4 6200ms linear 0ms infinite,qvncsRce_fade 6200ms linear 0ms infinite;}.qvncsRce_5{stroke-dasharray:35 37;stroke-dashoffset:36;animation:qvncsRce_draw_5 6200ms linear 0ms infinite,qvncsRce_fade 6200ms linear 0ms infinite;}.qvncsRce_6{stroke-dasharray:35 37;stroke-dashoffset:36;animation:qvncsRce_draw_6 6200ms linear 0ms infinite,qvncsRce_fade 6200ms linear 0ms infinite;}.qvncsRce_7{stroke-dasharray:35 37;stroke-dashoffset:36;animation:qvncsRce_draw_7 6200ms linear 0ms infinite,qvncsRce_fade 6200ms linear 0ms infinite;}@keyframes qvncsRce_draw{100%{stroke-dashoffset:0;}}@keyframes qvncsRce_fade{0%{stroke-opacity:1;}93.54838709677419%{stroke-opacity:1;}100%{stroke-opacity:0;}}@keyframes qvncsRce_draw_0{12.903225806451612%{stroke-dashoffset: 36}18.951612903225808%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes qvncsRce_draw_1{18.951612903225808%{stroke-dashoffset: 36}25%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes qvncsRce_draw_2{25%{stroke-dashoffset: 36}31.048387096774192%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes qvncsRce_draw_3{31.048387096774192%{stroke-dashoffset: 36}37.096774193548384%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes qvncsRce_draw_4{37.096774193548384%{stroke-dashoffset: 36}43.145161290322584%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes qvncsRce_draw_5{43.145161290322584%{stroke-dashoffset: 36}49.193548387096776%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes qvncsRce_draw_6{49.193548387096776%{stroke-dashoffset: 36}55.24193548387096%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes qvncsRce_draw_7{55.24193548387096%{stroke-dashoffset: 36}61.29032258064516%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusAnimation);
export default __webpack_public_path__ + "static/media/plus-animation.4d5a4a724eebec086938f86e696543b2.svg";
export { ForwardRef as ReactComponent };